var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5293 5.46983C10.6698 5.61045 10.7487 5.80108 10.7487 5.99983C10.7487 6.19858 10.6698 6.3892 10.5293 6.52983L5.80934 11.2498H19.9993C20.1983 11.2498 20.389 11.3288 20.5297 11.4695C20.6703 11.6102 20.7493 11.8009 20.7493 11.9998C20.7493 12.1987 20.6703 12.3895 20.5297 12.5302C20.389 12.6708 20.1983 12.7498 19.9993 12.7498H5.80934L10.5293 17.4698C10.603 17.5385 10.6621 17.6213 10.7031 17.7133C10.7441 17.8053 10.7662 17.9046 10.7679 18.0053C10.7697 18.106 10.7512 18.206 10.7135 18.2994C10.6757 18.3928 10.6196 18.4776 10.5484 18.5489C10.4772 18.6201 10.3923 18.6762 10.2989 18.714C10.2055 18.7517 10.1055 18.7702 10.0048 18.7684C9.90412 18.7666 9.8048 18.7446 9.7128 18.7036C9.6208 18.6626 9.538 18.6035 9.46934 18.5298L3.46934 12.5298C3.32889 12.3892 3.25 12.1986 3.25 11.9998C3.25 11.8011 3.32889 11.6105 3.46934 11.4698L9.46934 5.46983C9.60997 5.32938 9.80059 5.25049 9.99934 5.25049C10.1981 5.25049 10.3887 5.32938 10.5293 5.46983Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbtn);
export default __webpack_public_path__ + "static/media/backbtn.a16f9cee787fecbc0d40fbb9a8253696.svg";
export { ForwardRef as ReactComponent };